<template>
    <div class="article-giros">
        <div class="article-det">
            <div class="article-background" v-if="article.article_media">
                <div 
                    class="article-background__image"
                    v-if="article.media[0].mime_type.startsWith('image')"
                    :style="{ backgroundImage: `url(${article.article_media})` }"
                ></div>
                <video class="article__video" :src="article.article_media" v-if="article.media[0].mime_type.startsWith('video')"></video>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 article__description-container">
                    <h3 class="article-det__title"> {{ article.title }} </h3>
                    <div class="article-det__description" v-html="article.content"></div>
                </div>
                <div class="col-12 col-lg-6 article__form-container">
                   <app-call-to-action v-if="article.call_to_action_form"></app-call-to-action>
                </div>
            </div>
        </div>
        <div class="partners" v-if="partners.length > 0">
            <h2 class="partners__title">Parteneri</h2>
            <app-partners :partners="partners"></app-partners>
        </div>
    </div>
</template>

<script>
    import appCallToAction from './CallToAction';
    import appPartners from './Shared/Partners';
    import GlobalService from './../services/Global';
    
    export default {
        data () {
            return {
                article: {
                    media: [{mime_type: 'img'}]
                },
                carousel: {
                    carouselitems: {
                        
                    }
                },
                partners: []
            }
        },
        created () {
            this.getArticle()
        },
        components: {
            appCallToAction,
            appPartners
        },
        methods: {
            getArticle () {
                this.$http.get(`/article/${this.$route.params.slug}`)
                .then(response => {
                    this.article = response.data[0]
                    localStorage.setItem('formId', this.article.call_to_action_form)
                })
                .then(() => {
                    if(this.article.carousel_id) {
                        this.getCarousel(this.article.carousel_id)
                    }
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            getCarousel (id) {
                this.$http.get(`/carousel/${id}`)
                .then(response => {
                    this.carousel = response.data[0]
                    this.generatePartners()
                    GlobalService.initializeCarousel()
                })
                .catch(e => {
                    console.log(e)
                })
            },
            generatePartners () {
                this.partners = this.carousel.carouselitems.map((item) => {
                    return {
                        name: item.media[0].name,
                        link: item.link,
                        img: item.media_url
                    }
                })
            }
        }
    }
</script>
